// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const tipoFacturasFullfilledReducer = makeSetReducer(['tipo_facturas/fullfilled']);
